/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DeviceReportedCalibrationData } from './DeviceReportedCalibrationData';
import {
    instanceOfDeviceReportedCalibrationData,
    DeviceReportedCalibrationDataFromJSON,
    DeviceReportedCalibrationDataFromJSONTyped,
    DeviceReportedCalibrationDataToJSON,
} from './DeviceReportedCalibrationData';

/**
 * @type CalibrationDataOverviewDtoLastReportedByDevice
 * 
 * @export
 */
export type CalibrationDataOverviewDtoLastReportedByDevice = DeviceReportedCalibrationData;


export function CalibrationDataOverviewDtoLastReportedByDeviceFromJSON(json: any): CalibrationDataOverviewDtoLastReportedByDevice {
    return CalibrationDataOverviewDtoLastReportedByDeviceFromJSONTyped(json, false);
}

export function CalibrationDataOverviewDtoLastReportedByDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataOverviewDtoLastReportedByDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...DeviceReportedCalibrationDataFromJSONTyped(json, true) };
    return  DeviceReportedCalibrationDataFromJSONTyped(json, true);
}

export function CalibrationDataOverviewDtoLastReportedByDeviceToJSON(value?: CalibrationDataOverviewDtoLastReportedByDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfDeviceReportedCalibrationData(value)) {
        return DeviceReportedCalibrationDataToJSON(value as DeviceReportedCalibrationData);
    }

    return {};
}

/**
 * Check if a given object implements the CalibrationDataOverviewDtoLastReportedByDevice interface.
 */
export function instanceOfCalibrationDataOverviewDtoLastReportedByDevice(value: any): value is CalibrationDataOverviewDtoLastReportedByDevice {
    if (instanceOfDeviceReportedCalibrationData(value)) return true;
    return false;
}

